import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { Branch } from '../icon/icons/Branch';
import { PinProperty } from '../icon/icons/PinProperty';
import { Typography } from '../Typography';

interface PropertyMapKeyProps {
  category: string;
}

// Styles

const StyledKey = styled.ul`
  ${({ theme: { space } }) => css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: ${space.md};
    list-style: none;
    li {
      display: flex;
      flex-direction: row;
      gap: ${space.sm};
    }
  `}
`;

// JSX

export const PropertyMapKey: FC<PropertyMapKeyProps> = ({ category, ...rest }) => (
  <StyledKey {...rest}>
    <li>
      <Typography variant="titleSmall">Key</Typography>
    </li>
    <li>
      <PinProperty size="medium" color="brand" />
      {category === 'RESALE' ? (
        <Typography variant="bodySmall">Property for sale</Typography>
      ) : (
        <Typography variant="bodySmall">Property for rent</Typography>
      )}
    </li>
    <li>
      <PinProperty size="medium" color="black" />
      {category === 'RESALE' ? (
        <Typography variant="bodySmall">Property under offer / contracts exchanged</Typography>
      ) : (
        <Typography variant="bodySmall">Property let</Typography>
      )}
    </li>
    <li>
      <Branch size="medium" />
      <Typography variant="bodySmall">KFH Branch</Typography>
    </li>
  </StyledKey>
);
